import { useEffect } from 'react'
import ConfirmationCheck from '~images/common/confirmation-check.svg';

interface ReminderProps {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Reminder = ({ setIsModalOpen }: ReminderProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(false)
    }, 5000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="flex gap-5 mb-8 mt-4">
      <img width="24" src={ConfirmationCheck} alt="Success" />
      <div>You'll now receive enrollment reminders</div>
    </div>
  )
}

export default Reminder
